<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

import CountryLocationList from "./country-location-list";
/**
 * Country component
 */
export default {
  components: { Layout, PageHeader, CountryLocationList },
};
</script>

<template>
  <Layout>
    <country-location-list />
  </Layout>
</template>
